module.exports = __webpack_public_path__ + "img/05.7dfc93c4.jpg";